{
  "DocumentViewer_AcceptButton": "Accepteren",
  "DocumentViewer_CloseButton": "Dichtbij",
  "NAME": "DocumentViewer"
}